import React from 'react';

import { Button, Modal } from 'react-bootstrap';

export const InfoModal = ({
  title,
  message,
  onHide,
  show,
  isActionBtn = true,
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontWeight: 400 }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>

      <Modal.Footer>
        {isActionBtn ? (
          <Button block bsStyle="primary" onClick={onHide}>
            Ok
          </Button>
        ) : null}
      </Modal.Footer>
    </Modal>
  );
};
